import { render, staticRenderFns } from "./aboutAs.vue?vue&type=template&id=0ffe2b83&scoped=true"
import script from "./aboutAs.vue?vue&type=script&lang=js"
export * from "./aboutAs.vue?vue&type=script&lang=js"
import style0 from "./aboutAs.vue?vue&type=style&index=0&id=0ffe2b83&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe2b83",
  null
  
)

export default component.exports